import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})

export class ObservableInspService {
usuario$ = new EventEmitter<string>();
direccion$ = new EventEmitter<string>();
folioDire$ = new EventEmitter<number>();
folioPredio$ = new EventEmitter<number>();
siglasId$  = new EventEmitter<string>();
tiposInsp$  = new EventEmitter<string>();
comentario$ = new EventEmitter<string>();
correo$ =  new EventEmitter<string>();
constructor(){

}

}

